import React, { useState } from "react";
import { Modal, Button, Form, Space, Steps, Result } from "antd";
import { useStepsForm } from "sunflower-antd";

import Documents from "../../FormInputs/Documents";

const { Step } = Steps;

interface IModalProps {
  show: boolean;
  showModal: Function;
  handleAdd?: Function | undefined;
  memberId: any;
}

interface CardDataItem {
  CoveredName: string;
  CoveredSurname: string;
  CoveredIdNumber: string;
  // Add other properties if necessary
}

const AddCommunicationModal: React.FC<IModalProps> = ({
  show,
  showModal,
  handleAdd,
  memberId,
}) => {
  const [loading, setLoading] = useState(false);

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      if (handleAdd != undefined) {
        const response = await handleAdd(Number(memberId), {
          base64: values.base64,
          name: values.name,
        });

        if (response.success) {
          setLoading(false);
          return true;
        }
        setLoading(false);
        return false;
      }
    },
    total: 3,
  });

  // Step Styling
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const display: any = {
    0: <Documents loading={loading} gotoStep={gotoStep} current={current} submit={submit} />,
  };

  return (
    <Modal
      title="Add Communication"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={600}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        {current === 1 && <></>}
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {display[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title="Error occurred, please try again.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddCommunicationModal;
